import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log("Cambiando de sección a:", pathname);

    // Deshabilitar la animación de desplazamiento para forzar la aparición instantánea
    document.documentElement.style.scrollBehavior = "auto";
    document.body.style.scrollBehavior = "auto";

    // Forzar la posición en la parte superior
    window.scrollTo(0, 0);

    // También asegurarnos de resetear cualquier contenedor con scroll
    const mainContainer = document.querySelector("main");
    if (mainContainer) {
      mainContainer.scrollTop = 0;
    }

    // Restaurar el comportamiento de desplazamiento después del cambio
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "";
      document.body.style.scrollBehavior = "";
    }, 0);

  }, [pathname]);

  return null;
};

export default ScrollToTop;


